import { BrowserRouter as Router } from 'react-router-dom';
import history from './history'
import { ContextProvider } from '../src/context/contextApi'
import { ContextDrawerProvider } from './context/drawerContext';
import './styles/global.scss';
import Routes from './routes';
import { DrawerComponent } from './components/drawer/DrawerComponent';

function App() {
  return (
    <ContextProvider>
      <ContextDrawerProvider>
        <Router history={history}>
          <DrawerComponent />
          <Routes />
        </Router>
      </ContextDrawerProvider>
    </ContextProvider>
  );
}


export default App;
